import React from 'react';
import { CaretDown, CaretRight, UsersThree } from '@phosphor-icons/react';
import UserOrganizationCard from './UserOrganizationCard';

function OrgChartNodeCard({ node, hasChildren, isExpanded, onToggle, onNavigate, childCount }) {
  const isGroup = node.nodeType === 'group';

  if (isGroup) {
    return (
      <div className="org-tree-node-card w-[15rem] rounded-xl border-2 border-dashed border-indigo-200 bg-indigo-50/80 px-4 py-3 shadow-sm">
        <div className="flex items-start gap-2">
          {hasChildren && (
            <button
              type="button"
              onClick={() => onToggle(node.id)}
              className="mt-0.5 p-0.5 rounded hover:bg-indigo-100 text-indigo-600 shrink-0"
              aria-label={isExpanded ? 'Collapse group' : 'Expand group'}
            >
              {isExpanded ? <CaretDown size={14} weight="bold" /> : <CaretRight size={14} weight="bold" />}
            </button>
          )}
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <UsersThree size={18} className="text-indigo-600 shrink-0" />
              <p className="font-bold text-indigo-950 text-sm leading-tight">{node.name}</p>
            </div>
            <p className="text-[10px] uppercase tracking-wider text-indigo-600/80 mt-1">{node.groupKind || 'group'}</p>
            <p className="text-xs text-indigo-700/70 mt-1.5">{childCount} member{childCount === 1 ? '' : 's'}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="org-tree-node-card relative">
      {hasChildren && (
        <button
          type="button"
          onClick={() => onToggle(node.id)}
          className="absolute -top-2 -right-2 z-10 w-6 h-6 rounded-full bg-white border border-slate-200 shadow-sm flex items-center justify-center text-slate-500 hover:text-blue-600 hover:border-blue-300"
          aria-label={isExpanded ? 'Collapse' : 'Expand'}
        >
          {isExpanded ? <CaretDown size={12} weight="bold" /> : <CaretRight size={12} weight="bold" />}
        </button>
      )}
      <UserOrganizationCard node={node} onNavigate={onNavigate} compact />
    </div>
  );
}

export default OrgChartNodeCard;
